import React, {useEffect, useState} from "react";
import {createPortal} from "react-dom";
import {getDepartments} from "../../../department/DepartmentService";
import {getUserListWithNoPages} from "../../../../../api/user/UserAccountService";
import {getFlatCode} from "../../../../../components/commonmethod/CommonMethod";
import ApproveDeptTree from "./ApproveDeptTree";
import ApproveUserList from "./ApproveUserList";
import ApproveSelectedList from "./ApproveSelectedList";
import ApprovePreset from "./ApprovePreset";
import "../../../../../components/searchSelector/searchSelector.css";
import "./approveModal.css";

export default function ApproveModal({open, value, onChange, onReset, onClose}) {
    const [draft, setDraft] = useState(value ?? []);
    const [departments, setDepartments] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedDept, setSelectedDept] = useState(undefined);
    const [deptLoading, setDeptLoading] = useState(false);
    const [userLoading, setUserLoading] = useState(false);

    useEffect(() => {
        if (!open) return;
        setDraft(value ?? []);
        setSelectedDept(undefined);
    }, [open, value]);

    useEffect(() => {
        if (!open) return undefined;
        let cancelled = false;
        setDeptLoading(true);
        getDepartments()
            .then((res) => {
                if (cancelled) return;
                setDepartments(res?.status === 200 ? res.data?.content ?? [] : []);
            })
            .finally(() => {
                if (!cancelled) setDeptLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [open]);

    useEffect(() => {
        if (!open) return undefined;
        let cancelled = false;
        setUserLoading(true);
        // 하위 부서까지 포함해 조회 — 서버는 department 로 조건 유무를 판단하고 departmentList 로 필터한다
        const search = selectedDept
            ? {
                department: {id: selectedDept.id},
                departmentList: getFlatCode([selectedDept]).map((dept) => ({id: dept.id})),
            }
            : {};
        getUserListWithNoPages(search)
            .then((res) => {
                if (cancelled) return;
                setUsers(res?.status === 200 && Array.isArray(res.data) ? res.data : []);
            })
            .finally(() => {
                if (!cancelled) setUserLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [open, selectedDept]);

    // draft를 전부 지워도 부모(value)에는 결재선이 남아 있으므로 둘 다 본다
    const canReset = (draft?.length ?? 0) > 0 || (value?.length ?? 0) > 0;

    const handleReset = async () => {
        if (!window.confirm("결재선을 초기화하시겠습니까?")) return;
        setDraft([]);
        await onReset?.();
        onClose?.();
    };

    if (!open) return null;

    return createPortal(
        <div className="approve-modal-overlay" onClick={onClose}>
            <div className="approve-modal" onClick={(e) => e.stopPropagation()}>
                <div className="approve-modal__header">결재자 선택</div>

                <div className="search-selector-panel approve-modal__panel">
                    <div className="search-selector-panel-body">
                        <aside className="search-selector-panel-sidebar">
                            <div className="search-selector-panel-sidebar-content">
                                <ApproveDeptTree
                                    data={departments}
                                    loading={deptLoading}
                                    selectedDeptId={selectedDept?.id}
                                    onSelect={setSelectedDept}
                                />
                            </div>
                        </aside>

                        <div className="search-selector-panel-main">
                            <ApproveUserList
                                users={users}
                                loading={userLoading}
                                values={draft}
                                setValues={setDraft}
                            />
                        </div>

                        <aside className="approve-modal__selected">
                            <ApprovePreset
                                values={draft}
                                onSelectPreset={(approvers) => setDraft(approvers)}
                            />
                            <div className="approve-modal__selected-head">결재순서</div>
                            <div className="approve-modal__selected-body">
                                <ApproveSelectedList values={draft} setValues={setDraft} />
                            </div>
                        </aside>
                    </div>
                </div>

                <div className="approve-modal__footer">
                    {onReset ? (
                        <button
                            type="button"
                            className="approve-modal__btn approve-modal__btn--reset"
                            disabled={!canReset}
                            onClick={handleReset}
                        >
                            초기화
                        </button>
                    ) : null}
                    <button type="button" className="approve-modal__btn" onClick={onClose}>
                        취소
                    </button>
                    <button
                        type="button"
                        className="approve-modal__btn approve-modal__btn--primary"
                        onClick={async () => {
                            if (onChange) {
                                const shouldClose = await onChange(draft);
                                if (shouldClose === false) {
                                    return;
                                }
                            }
                            onClose?.();
                        }}
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>,
        document.body,
    );
}
